import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LOADING_STATUS } from '../../../shared/constants/loadingStatus';
import { CHANNEL } from '../constants/messageTemplateKeys';
import { loadMessageTemplates, loadMessageTemplateFacets } from '../store/templatesSlice';

const TAB_KEYS = [CHANNEL.EMAIL, 'text'];

export function useTemplatesTabPrefetch(apiReady, tabs) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!apiReady) return;
    for (const tabKey of TAB_KEYS) {
      const listStatus = tabs?.[tabKey]?.listStatus ?? LOADING_STATUS.IDLE;
      if (listStatus === LOADING_STATUS.IDLE) {
        dispatch(loadMessageTemplates({ tabKey }));
      }
    }
  }, [dispatch, apiReady, tabs]);

  useEffect(() => {
    if (!apiReady) return;
    for (const tabKey of TAB_KEYS) {
      const facetsStatus = tabs?.[tabKey]?.facetsStatus ?? LOADING_STATUS.IDLE;
      if (facetsStatus === LOADING_STATUS.IDLE) {
        dispatch(loadMessageTemplateFacets({ tabKey }));
      }
    }
  }, [dispatch, apiReady, tabs]);
}
